import { useStanQuery } from '@/queries';
import { mainApi } from '@/lib/api';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import type { Store } from '@/types/store';
import type { FunnelAnalyticsMap } from '../types';

/**
 * Fetch a single funnel by store ID
 */
export function useFunnelDetail(storeId: number | undefined) {
    return useStanQuery<Store | null>({
        queryKey: [QUERY_KEYS.FUNNELS, 'detail', storeId],
        queryFn: async () => {
            if (!storeId) return null;
            const response = await mainApi.get<{ store: Store }>(`v1/stores/${storeId}`, {
                params: { type: 'funnel' },
            });
            return response.data.store;
        },
        enabled: !!storeId,
        meta: {
            error: {
                sentryMessage: '[FUNNELS] failed-to-fetch-funnel-detail',
                feature: SENTRY_FEATURES.FUNNELS,
            },
        },
    });
}

/**
 * Fetch funnel analytics for all funnels
 */
export function useFunnelAnalytics() {
    return useStanQuery<FunnelAnalyticsMap>({
        queryKey: [QUERY_KEYS.FUNNELS, 'analytics'],
        queryFn: async () => {
            const response = await mainApi.get<FunnelAnalyticsMap>('v1/stores/analytics');
            return response.data;
        },
        meta: {
            error: {
                sentryMessage: '[FUNNELS] failed-to-fetch-funnel-analytics',
                feature: SENTRY_FEATURES.FUNNELS,
            },
        },
    });
}
